import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'METRO_DISTANCE',
  analyticsName: 'Subway',
  queryKey: 'f_metro_dist',
  type: FILTER_TYPES.DISTANCE,
  caId: 'distanceToNearestMetro',
  bucketify: (hotel) => {
    const distanceFacts = hotel?.distanceFacts;

    // TODO: för att få med hotell utan värden på 0-bucketen behöver alla hotell raportera att de har värde,
    //       sen måste vi låtsas att den har avstånd 0 i filterTypen

    // TODO: Se till så att nollställning av distansfilter flyttar upp slidern till max istället för ner till 0 som nu.
    const distanceFact = distanceFacts?.find?.((fact) => {
      return fact?.id === 'distanceToMetro';
    });

    if (!distanceFact) {
      return undefined;
    }

    // TODO: put the id somewhere else (also for price)!
    return {
      bucketId: 'hasDistance',
      bucketName: 'distanceToNearestMetro',
    };
  },
  decorateFinalState: (finalState, _filterTree, _memory, { steps = [] }) => {
    finalState.values = finalState.values || {};
    finalState.values.maximumDistance = steps[steps.length - 1];
  },
  toQuery: ({ value }, filterStateValues) => {
    const maximumDistance = filterStateValues?.maximumDistance;
    return value && value < maximumDistance ? value : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      selectedDistance: +rawQueryValue,
    };
  },
  reset: (currentState) => {
    // NB: We do not want to save selectedDistance since the filter is reset
    //     (slider set to max)
    return {
      hasDistance: currentState?.hasDistance,
      maximumDistance: currentState?.maximumDistance,
    };
  },
}));
